import { useState } from "react";
import { toast } from "sonner";
import { Copy, Mail, MessageSquare, Share2, Link2 } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { api, errMsg } from "../lib/api";
import { useApp } from "../context/AppContext";

export function InviteSheet({ open, onOpenChange, onCreated }) {
  const { sp, current } = useApp();
  const [label, setLabel] = useState("");
  const [inv, setInv] = useState(null);
  const [busy, setBusy] = useState(false);

  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(sp("/invitations"), { label });
      setInv(data);
      onCreated?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };

  const close = (v) => {
    onOpenChange(v);
    if (!v) { setInv(null); setLabel(""); }
  };

  const text = inv ? `Bonjour${label ? " " + label : ""}, rejoignez l'équipe « ${current?.name} » sur AVELIS Planning : ${inv.url}` : "";
  const copy = async () => {
    await navigator.clipboard.writeText(inv.url).catch(() => {});
    toast.success("Lien copié");
  };
  const share = async () => {
    if (navigator.share) await navigator.share({ title: "Invitation AVELIS Planning", text, url: inv.url }).catch(() => {});
    else copy();
  };

  return (
    <Sheet open={open} onOpenChange={close}>
      <SheetContent side="bottom" className="max-h-[90vh] overflow-y-auto rounded-t-3xl bg-white" data-testid="invite-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-xl">Inviter une infirmière</SheetTitle>
          <p className="text-sm text-slate-500">Lien personnel, valable pour un seul compte. Rôle attribué : Infirmière.</p>
        </SheetHeader>
        {!inv ? (
          <div className="mt-5 space-y-4">
            <label className="block">
              <span className="label">Prénom de la personne (facultatif)</span>
              <input className="field" value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Ex. Sarah" data-testid="invite-label-input" />
            </label>
            <button className="btn-primary w-full" onClick={create} disabled={busy} data-testid="invite-generate-btn">
              <Link2 className="h-5 w-5" /> Générer l'invitation
            </button>
          </div>
        ) : (
          <div className="mt-5 space-y-3">
            <div className="break-all rounded-xl border border-teal-100 bg-teal-50 p-3 font-mono text-xs text-teal-900" data-testid="invite-link-value">{inv.url}</div>
            <div className="grid grid-cols-2 gap-3">
              <a className="btn-primary !bg-[#25D366] hover:!bg-[#1ebe5a]" data-testid="share-whatsapp-btn" href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer">WhatsApp</a>
              <a className="btn-soft" data-testid="share-sms-btn" href={`sms:?&body=${encodeURIComponent(text)}`}><MessageSquare className="h-4 w-4" /> SMS</a>
              <a className="btn-soft" data-testid="share-email-btn" href={`mailto:?subject=${encodeURIComponent("Invitation – " + (current?.name || ""))}&body=${encodeURIComponent(text)}`}><Mail className="h-4 w-4" /> E-mail</a>
              <button className="btn-soft" data-testid="share-copy-link-btn" onClick={copy}><Copy className="h-4 w-4" /> Copier</button>
            </div>
            <button className="btn-ghost w-full" onClick={share} data-testid="share-native-btn"><Share2 className="h-4 w-4" /> Partager…</button>
            <button className="w-full py-3 text-sm font-semibold text-teal-700" onClick={() => { setInv(null); setLabel(""); }} data-testid="invite-another-btn">Nouvelle invitation</button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
